import "./BakeryCard.css";

import {
  MdEdit,
  MdDelete,
  MdVisibility,
} from "react-icons/md";
import getImageUrl from "../../../../../../utils/imageUrl";
function BakeryCard({
  product,
  onView,
  onEdit,
  onDelete,
}) {

  const image = product.image
  ? getImageUrl(product.image)
  : "/images/food-placeholder.png";

  return (
    <div className="bakery-card">

      <img
  src={image}
  alt={product.productName || "Bakery product"}
  onError={(event) => {
    event.currentTarget.src =
      "/images/food-placeholder.png";
  }}
/>

      <div className="bakery-card-body">

        <h3>{product.productName}</h3>

        <span className="category">
          {product.category}
        </span>

        <div className="price-row">

          <h2>₹{product.offerPrice}</h2>

          {product.price !== product.offerPrice && (
            <del>₹{product.price}</del>
          )}

        </div>

        <div className="product-info">

          <span>{product.weight}</span>

          <span>{product.flavour}</span>

          <span>
            {product.eggType}
          </span>

        </div>

        <div className="card-actions">

          <button
            onClick={() => onView(product)}
          >
            <MdVisibility />
          </button>

          <button
            onClick={() => onEdit(product)}
          >
            <MdEdit />
          </button>

          <button
            onClick={() => onDelete(product)}
          >
            <MdDelete />
          </button>

        </div>

      </div>

    </div>
  );
}

export default BakeryCard;